// extracted by mini-css-extract-plugin
module.exports = {"comp":"D_comp__tuYza"};